import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, Button, ButtonGroup } from '@mui/material';
import moment from 'moment';
import {
  buttonStyles,
  labelStyles,
  navigationContainerStyles,
  toolbarContainerStyles,
  viewButtonStyles,
} from './CalendarToolbar.styles';
import { CalendarToolbarProps } from './CalendarToolbar.types';

const getLabel = (date: Date, view: string): string => {
  if (view === 'month') {
    return moment(date).format('MMMM YYYY');
  }
  if (view === 'week') {
    return `${moment(date).startOf('week').format('MMM D')} – ${moment(date).endOf('week').format('MMM D, YYYY')}`;
  }
  return moment(date).format('dddd, MMMM D, YYYY');
};

const CalendarToolbar = ({ date, view, onNavigate, onViewChange, views }: CalendarToolbarProps) => {
  const label = getLabel(date, view);

  return (
    <Box sx={toolbarContainerStyles}>
      <Box sx={navigationContainerStyles}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => onNavigate('TODAY')}
          sx={buttonStyles}
        >
          Today
        </Button>
        <ButtonGroup size="small" variant="outlined">
          <Button onClick={() => onNavigate('PREV')}>
            <ChevronLeft fontSize="small" />
          </Button>
          <Button onClick={() => onNavigate('NEXT')}>
            <ChevronRight fontSize="small" />
          </Button>
        </ButtonGroup>
        <Box sx={labelStyles}>
          {label}
        </Box>
      </Box>
      <ButtonGroup size="small" variant="outlined">
        {views.map(v => (
          <Button
            key={v}
            onClick={() => onViewChange(v)}
            variant={view === v ? 'contained' : 'outlined'}
            sx={viewButtonStyles}
          >
            {v}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default CalendarToolbar;
